import { types as sdkTypes } from './sdkLoader';

const { UUID } = sdkTypes;

export const FAVORITE_LISTING_IDS_KEY = 'favoriteListingIds';

export const asUUID = id => {
  if (!id) return null;
  if (id instanceof UUID) return id;
  if (typeof id === 'string') {
    try {
      return new UUID(id);
    } catch (e) {
      return null;
    }
  }
  if (typeof id === 'object' && typeof id.uuid === 'string') {
    return asUUID(id.uuid);
  }
  return null;
};

export const getFavoriteListingIds = currentUser => {
  const publicData = currentUser?.attributes?.profile?.publicData || {};
  const ids = publicData?.[FAVORITE_LISTING_IDS_KEY];
  return Array.isArray(ids) ? ids.filter(v => typeof v === 'string') : [];
};

export const hasFavoriteListingId = (currentUser, listingId) => {
  const id = asUUID(listingId);
  if (!id) return false;
  const favorites = getFavoriteListingIds(currentUser);
  return favorites.includes(id.uuid);
};

export const toggleFavoriteListingId = (currentUser, listingId) => {
  const id = asUUID(listingId);
  if (!id) return getFavoriteListingIds(currentUser);
  const favorites = getFavoriteListingIds(currentUser);
  const exists = favorites.includes(id.uuid);
  return exists ? favorites.filter(f => f !== id.uuid) : [id.uuid, ...favorites];
};

export const removeFavoriteListingId = (currentUser, listingId) => {
  const id = asUUID(listingId);
  if (!id) return getFavoriteListingIds(currentUser);
  const favorites = getFavoriteListingIds(currentUser);
  return favorites.filter(f => f !== id.uuid);
};
